import { uploadMutations } from 'entities/modules/uploads';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { TaskComment } from '../types';
import { fileNameToReadable } from 'utils/text';

export const taskCommentMutations = getMutations({
  createTaskComment: {
    action: async ({
      files = [],
      ...payload
    }: {
      task: string;
      project: string;
      text: string;
      files?: Array<{
        file: File;
        name: string;
      }>;
    }): Promise<TaskComment> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        prefix: `projects/${payload.project}`,
        files: files.map((f) => f.file),
      });

      return executeApiCall({
        method: 'post',
        path: 'projects/tasks/comment',
        payload: {
          ...payload,

          files: filePayload.files.map((file, index) => ({
            ...file,
            filename: file.name,
            name: files[index]?.name || fileNameToReadable(file.name),
          })),
        },
      });
    },

    messages: {
      suppressSuccess: true,
      error: (t) => ({
        title: t('could-not-create-comment'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  updateTaskComment: {
    action: async (payload: {
      task: string;
      timestamp: string;
      text: string;
    }): Promise<TaskComment> => {
      return executeApiCall({
        path: '/projects/tasks/comment',
        method: 'put',
        payload,
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },
});
